/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Coach } from '../models/Coach';
import type { Player } from '../models/Player';
import type { Referee } from '../models/Referee';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RefereeService {
    /**
     * Get Person
     * @param personId
     * @param activeTeamsOnly
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getPersonPersonPersonIdGet(
        personId: number,
        activeTeamsOnly: boolean = true,
    ): CancelablePromise<(Player | Coach | Referee)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/person/{person_id}',
            path: {
                'person_id': personId,
            },
            query: {
                'active_teams_only': activeTeamsOnly,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Image From Person
     * @param personId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteImageFromPersonPersonImagePersonIdDelete(
        personId: number,
    ): CancelablePromise<(string | null)> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/person/image/{person_id}',
            path: {
                'person_id': personId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
